import dayjs from "dayjs";

export default function formatExpireAt(date, type = "diff") {
  if (!date) {
    return type === "diff" ? "Sem validade" : "grey";
  }

  const exp = dayjs(date);
  const now = dayjs();

  const formattedDate = exp.format("DD/MM/YY [às] HH[h]mm");

  const diffMinutes = exp.diff(now, "minute");
  const diffHours = exp.diff(now, "hour");
  const diffDays = exp.diff(now, "day");

  if (type === "tooltip") {
    return diffMinutes < 0
      ? `Expirou em ${formattedDate}`
      : `Expira em ${formattedDate}`;
  }

  if (diffMinutes < 0) {
    return result(type, "Vencido", "error");
  }

  if (diffMinutes < 60) {
    return result(type, `Em ${diffMinutes} min`, "deep-orange");
  }

  if (diffHours < 24) {
    return result(type, `Em ${diffHours}h`, "deep-orange");
  }

  if (diffDays < 7) {
    return result(type, `Em ${diffDays} dias`, "amber");
  }

  return result(type, `Em ${diffDays} dias`, "success");
}

function result(type, text, color) {
  return type === "diff" ? text : color;
}
